import request from '../utils/request';
const querystring = require('querystring')
 
//获取列表数据
export const fetchData = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'rootPay/selectPage.do',
        method: 'post',
        params: query
    }); 
    return list;
};
 


//启用-禁用 
export const changeStatus = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'rootPay/changeStatus.do',
        method: 'post',
        params: query
    }); 
    return list;
};

export const fetchSelect = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'rootPay/getSelect.do',
        method: 'post',
        params: query
    }); 
    return list;
};


//添加渠道信息
export const saveForm = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'rootPay/insert.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};

export const handDelete = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'rootPay/delete.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};

export const changeForm = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'rootPay/update.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};




 



